export default __webpack_public_path__ + "static/omoArsenal-fca7dc39365f3a8057b3272fba29edbd.svg";